module.exports = __webpack_public_path__ + "site/img/tree.73afae87.png";